import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { Hog } from "./hog.tsx";
import { clearCacheBusterParam, clearDismissedVersion } from "@/lib/versioning";
import "./index.css";

clearCacheBusterParam();
clearDismissedVersion();

createRoot(document.getElementById("root")!).render(
  <Hog>
    <div className="bg-background">
      <App />
    </div>
  </Hog>,
);
